import { clientError, clientLoaded, fetchClient } from "./client";
import { apiService } from "../store";
import { messageError } from "./index";

export const childrenRequested = (data) => {
  return {
    type: "CHILDREN_REQUEST",
    payload: data,
  };
};
export const childrenLoading = () => {
  return {
    type: "CHILDREN_LOADING",
  };
};

export const setChildrenId = (id) => {
  return {
    type: "CHILD_ID",
    payload: id,
  };
};

export const childRequested = (child) => {
  return {
    type: "CHILD_REQUEST",
    payload: child,
  };
};
export const updateChild = (child) => {
  return {
    type: "UPDATE_CHILD",
    payload: child,
  };
};
export const stateStatusChildren = (data) => {
  return {
    type: "STATE_STATUS_CHILDREN",
    payload: data,
  };
};

export const getChildrenRequested = () => (dispatch) => {
  dispatch(childrenLoading());
  apiService.childrenRequested().then((data) => {
    const children = data.map((item) => ({
      ...item,
      full_name: `${item.last_name} ${item.first_name} ${
        item.middle_name === null ? "" : item.middle_name
      }`,
    }));
    const date = children
      .map((item) => {
        const today = new Date();
        const birthDate = new Date(item.birthday);
        let age_now = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age_now--;
        }
        return { ...item, age: age_now };
      })
      .reverse();
    dispatch(childrenRequested(date));
  });
};

export const statusChildren = () => (dispatch) => {
  apiService.statusChildren().then((data) => {
    dispatch(stateStatusChildren(data));
  });
};

export const childRequest = (id) => (dispatch) => {
  dispatch(childrenLoading());
  apiService.childRequest(id).then((data) => {
    dispatch(childRequested(data));
  });
};

export const childUpdate = (child) => (dispatch) => {
  apiService.updateChild(child).then((data) => {
    dispatch(updateChild(data));
    apiService
      .getClientRequest(child.client_id)
      .then((data) => {
        const client = { ...data, history: data.history };
        dispatch(clientLoaded(client));
      })
      .catch((err) => dispatch(clientError(err)));
    dispatch(getChildrenRequested());
  });
};
export const childCreate = (child) => (dispatch) => {
  apiService.createChild(child).then((data) => {
    dispatch(fetchClient(child.client_id));
    dispatch(childRequested(data));
    dispatch(getChildrenRequested());
  });
};
export const childDelete = (child) => (dispatch) => {
  apiService
    .deleteChild(child)
    .then(() => {
      dispatch(fetchClient(child.client_id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const createHistoryChild = (required, payload) => (dispatch) => {
  apiService
    .createHistory(required, payload)
    .then(() => {
      apiService.childRequest(payload.id).then((data) => {
        dispatch(childRequested(data));
      });
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
